<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@ds/lib/utils'

const props = defineProps<{ class?: HTMLAttributes['class'] }>()
</script>

<template>
  <div
    :class="
      cn(
        'flex flex-col-reverse gap-y-2 sm:flex-row sm:justify-end sm:gap-x-2.5 sm:gap-y-0 px-6 py-4',
        props.class,
      )
    "
  >
    <slot />
  </div>
</template>
